import { component } from 'picoapp';
import { gsap } from 'gsap';

function StickyBar(node) {

  const tl = gsap.timeline({
    paused: true
  });
  tl.set(node, { display: 'block', immediateRender: false });
  tl.from(node, { yPercent: -100, opacity: 0, duration: 0.2, ease: 'power2.out' });


  window.onscroll = () => {
    if (window.pageYOffset > 100) {
      tl.play()
    } else {
      tl.reverse();
    }
  };

}

export default component((node, ctx) => {
  new StickyBar(node, ctx);
});
